import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./Header.css";
import logo from "../images/logo-.png";
import { TelephoneFill } from "react-bootstrap-icons"; // optional icon

export default function Header() {
  const [showCourse, setShowCourse] = useState(false);
  const [expanded, setExpanded] = useState(false); // 👈 control navbar state

  return (
    <Navbar
      collapseOnSelect
      expanded={expanded}
      onToggle={setExpanded}
      expand="lg"
      fixed="top"
      className="shadow-sm py-2 header2"
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="d-flex align-items-center"
          onClick={() => setExpanded(false)}
        >
          <img
            src="/images/BDElogo.png"
            alt="Bangalore distance education header logo"
            style={{ height: "60px",marginRight: "8px" }}
          />
        </Navbar.Brand>

        {/* Mobile Toggle */}
        <Navbar.Toggle aria-controls="main-navbar" />

        {/* Menu */}
        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto align-items-lg-center nav-menu">
            <Nav.Link
              className="nav-link"
              as={NavLink}
              to="/"
              end
              onClick={() => setExpanded(false)}
            >
              HOME
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              className="nav-link"
              to="/about"
              onClick={() => setExpanded(false)}
            >
              ABOUT US
            </Nav.Link>

            {/* Dropdown with hover */}
            <NavDropdown
              title="COURSE"
              id="course-dropdown"
              show={showCourse}
              onMouseEnter={() => setShowCourse(true)}
              onMouseLeave={() => setShowCourse(false)}
            >
              {[
                ["MCA", "mca"],
                ["MBA", "mba"],
                ["MCOM", "mcom"],
                ["MA", "ma"],
                ["BCOM", "bcom"],
                ["BCA", "bca"],
                ["BBA", "bba"],
                ["PHD", "phd"],
              ].map(([label, path]) => (
                <NavDropdown.Item
                  key={path}
                  as={NavLink}
                  to={`/courses/${path}`}
                  onClick={() => setExpanded(false)} // 👈 collapse after select
                >
                  {label} Course
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            <Nav.Link
              as={NavLink}
              to="/bosse"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              BOSSE
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/blog"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              BLOGS
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/contact"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              CONTACT US
            </Nav.Link>

            {/* CTA Button */}

            <a href="tel:+911234567890" className="fw-bold text-primary">
              <TelephoneFill className="me-1" />
              +91 9035600400
            </a>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
